export const PAGES = {
  HOME: '/',
  SIGN_IN: '/sign-in',
  PASSWORD_RESET: '/password-reset',
  TEAM_REGISTRATION: '/team-registration',
  PLAYER_REGISTRATION: '/player-registration',
} as const;
